<template>
  <div>
    <Collapse v-model="collasePanel" simple>
      <Panel name="1">
        <span>{{ $t("PB_Basic_Information") }}</span
        ><!--个人信息-->
        <div slot="content">
          <Form
            :model="formItem"
            :label-width="135"
            label-position="left"
            :disabled="prevent"
          >
            <Row :gutter="40">
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Age')"
                  ><!--年龄-->
                  <Input type="number" v-model="formItem.age" />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Gender')"
                  ><!--性别-->
                  <Select :clearable="true" v-model="formItem.gender">
                    <Option
                      v-for="(item, index) in Gender"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Position')"
                  ><!--职位-->
                  <Input v-model="formItem.position" />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Band')"
                  ><!--职级-->
                  <Select :clearable="true" v-model="formItem.hcmBand">
                    <Option
                      v-for="(item, index) in Band"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('BU')"
                  ><!--业务单元-->
                  <Select :clearable="true" v-model="formItem.businessUnit">
                    <Option
                      v-for="(item, index) in businessUnitList"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Department')"
                  ><!-- 大区 -->
                  <Select
                    v-model="formItem.department"
                    placeholder=""
                    clearable
                  >
                    <Option
                      v-for="item in departmentList"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Funciton')"
                  ><!-- 职能 -->
                  <Select clearable v-model="formItem.postFun" placeholder="">
                    <Option
                      v-for="item in functionList"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="this.$t('DepartmentSalesRegion')"
                  ><!-- 部门/销售区域 -->
                  <Select v-model="formItem.salesArea" clearable>
                    <Option
                      v-for="item in salesAreaList"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Location_PPT')"
                  ><!--工作地点-->
                  <Input v-model="formItem.district" />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('In position since')"
                  ><!--本岗位开始时间-->
                  <DatePicker
                    type="date"
                    :transfer="true"
                    @on-change="formItem.changedate = $event"
                    v-model="formItem.changedate"
                    style="width: 100%"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('In Carlsberg since')"
                  ><!--嘉士伯入职时间-->
                  <DatePicker
                    type="date"
                    :transfer="true"
                    @on-change="formItem.hirevalid = $event"
                    v-model="formItem.hirevalid"
                    style="width: 100%"
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Language_s')"
                  ><!--语言-->
                  <Select :clearable="true" v-model="formItem.language">
                    <Option
                      v-for="(item, index) in Language"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('PersonelType2')"
                  ><!-- personneltype2 -->
                  <Select v-model="formItem.personnelType" clearable>
                    <Option
                      v-for="item in personnelType"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('IsNotSTIEmp')"
                  ><!-- 是否有STI -->
                  <Select v-model="formItem.perresult" clearable>
                    <Option
                      v-for="item in YesOrNo"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem label="在职状态"
                  ><!-- 是否有STI -->
                  <Select v-model="formItem.beQuit" clearable>
                    <Option
                      v-for="item in BeQuit"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="this.$t('GroupSelect')">
                  <UserGroupList
                    ref="UserGroupList"
                    @confirmSelectGroup="confirmSelectGroup"
                  ></UserGroupList>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
      </Panel>
      <div class="cs-more" v-if="!isShowMore" @click="isShowMore = true">
        {{ $t("Select_More") }}
      </div>
      <!--查看更多-->
      <Panel name="2" v-if="isShowMore">
        <span>{{ $t("PB_Performance_Potential") }}</span
        ><!--绩效潜能-->
        <div slot="content">
          <Form
            :model="formItem"
            :label-width="120"
            label-position="left"
            :disabled="prevent"
          >
            <Row :gutter="40">
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Performance_Year')"
                  ><!--绩效年度-->
                  <Select :clearable="true" v-model="formItem.achYear">
                    <Option
                      v-for="(item, index) in AchYear"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Potential')"
                  ><!--潜能-->
                  <Select :clearable="true" v-model="formItem.potentialScore">
                    <Option
                      v-for="(item, index) in PotentialScore"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
      </Panel>
      <Panel name="3" v-if="isShowMore">
        <span>{{ $t("Inventory_Information") }}</span
        ><!--盘点信息-->
        <div slot="content">
          <Form
            :model="formItem"
            :label-width="150"
            label-position="left"
            :disabled="prevent"
          >
            <Row :gutter="40">
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Attrition_Risk')"
                  ><!--离职风险-->
                  <Select v-model="formItem.exitRisk" transfer clearable>
                    <Option
                      v-for="item in ExitRisk"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                  <!-- <Input v-model="formItem.exitRisk"  /> -->
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Impact_of_Attrition')"
                  ><!--离职影响-->
                  <Input v-model="formItem.exitAffect" />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Mobility_Cross_Region')"
                  ><!--能动性（跨地域）-->
                  <Select :clearable="true" v-model="formItem.crossRegion">
                    <Option
                      v-for="(item, index) in CrossRegional"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Mobility_Cross_Function')"
                  ><!--能动性（跨职能）-->
                  <Select :clearable="true" v-model="formItem.crossFun">
                    <Option
                      v-for="(item, index) in YesOrNo"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Readiness_for_Next_Position')"
                  ><!--下一岗位的准备度Readiness-->
                  <!-- <Input v-model="formItem.nextJob"  /> -->
                  <Select v-model="formItem.nextJob" clearable>
                    <Option
                      v-for="item in NextJob"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Releasibility_')"
                  ><!--业务可释放的时间Releasability-->
                  <Select v-model="formItem.releaseDate" clearable transfer>
                    <Option
                      v-for="item in ServiceRelease"
                      :value="item.code"
                      :key="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                  <!-- <DatePicker type="date" :transfer="true" v-model="formItem.releaseDate" style="width:100%"></DatePicker> -->
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Talent_Pool')"
                  ><!--放入哪个人才库-->
                  <Select :clearable="true" v-model="formItem.postFun">
                    <Option
                      v-for="(item, index) in functionList"
                      :key="index"
                      :value="item.code"
                      >{{
                        lang == "zh" ? item.ch_value : item.en_value
                      }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="6">
                <FormItem :label="$t('Successor Candidate_Role')"
                  ><!--哪个岗位的继任者-->
                  <Input v-model="formItem.successorPosition" />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
      </Panel>
      <div class="cs-more" v-if="isShowMore" @click="isShowMore = false">
        {{ $t("Collapse") }}
      </div>
      <!--收起-->
    </Collapse>
    <div class="searchBtn">
      <Button type="primary" @click="(pageInfo.pageNo = 1), getData()">{{
        $t("Search")
      }}</Button>
      <Button style="margin-left: 20px" @click="handleReset()"
        ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
      >
    </div>
    <!--检索-->

    <Card style="margin-top: 20px">
      <div class="contentBox">
        <div class="matchFieldLeft">
          <Collapse v-model="contentBoxcollasePanel" simple>
            <Panel name="1">
              <span>{{ $t("Basic_Information") }}</span
              ><!--个人信息-->
              <div slot="content">
                <CheckboxGroup v-model="matchField1">
                  <Checkbox
                    style="margin: 5px 15px 5px 0"
                    v-for="(item, index) in matchFieldList1"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </Panel>
            <Panel name="2">
              <span>{{ $t("Inventory_Information") }}</span
              ><!--盘点信息-->
              <div slot="content">
                <CheckboxGroup
                  v-model="matchField2"
                  @on-change="matchFieldList2OnChange"
                >
                  <span v-for="(item, index) in matchFieldList2" :key="index">
                    <Checkbox
                      :disabled="item.disabled"
                      style="margin: 5px 15px 5px 0"
                      :label="item.value"
                      >{{ item.label }}</Checkbox
                    >
                    <br v-if="item.value == '9-5' || item.value == '10-5'" />
                  </span>
                </CheckboxGroup>
              </div>
            </Panel>
            <Panel name="3">
              <span>{{ $t("CAREER_PROFILE") }}</span
              ><!--职业档案-->
              <div slot="content">
                <CheckboxGroup v-model="matchField3">
                  <Checkbox
                    style="margin: 5px 15px 5px 0"
                    v-for="(item, index) in matchFieldList3"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </Panel>
            <Panel name="4">
              <span>{{ $t("Development_Plan") }}</span
              ><!--发展计划-->
              <div slot="content">
                <CheckboxGroup v-model="matchField4">
                  <Checkbox
                    style="margin: 5px 15px 5px 0"
                    v-for="(item, index) in matchFieldList4"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </Panel>
          </Collapse>
        </div>
        <div class="matchFieldRight">
          <Table
            :loading="loading"
            @on-selection-change="peoOnSelect"
            @on-select-all-cancel="cancelAll"
            @on-select-cancel="TableSelectCancelRow"
            @on-select-all="selsetAll"
            @on-select="peoOnSelectRow"
            height="500"
            :columns="columns"
            :data="dataTable"
          >
            <template slot="userName" slot-scope="{ row }">
              <div class="employeeBox">
                <Avatar
                  v-if="row.portrait"
                  :src="'data:image/jpeg;base64,' + row.portrait || ''"
                  size="large"
                />
                <Avatar v-else icon="ios-person" size="large" />
                <div class="employeeContent">
                  <span>{{ lang == "zh" ? row.userName : row.userEName }}</span>
                  <p>
                    {{ lang == "zh" ? row.position : row.enPosition }}
                    {{ lang == "zh" ? row.businessUnit : row.enBusinessUnit }}
                  </p>
                </div>
              </div>
            </template>
          </Table>
          <div
            style="display: flex; justify-content: flex-end; margin-top: 30px"
          >
            <Page
              :total="total"
              :current="pageInfo.pageNo"
              transfer
              :page-size="pageInfo.pageSize"
              @on-change="pageChange"
              :page-size-opts="[10, 50, 100, 150]"
              show-sizer
              @on-page-size-change="pageSizeChange"
            />
          </div>
        </div>
      </div>
      <div class="searchBtn">
        <Button
          type="primary"
          :disabled="matchLoading"
          @click="modalMatchClick"
          >{{ $t("Comparison") }}</Button
        >
      </div>
      <!--比较-->
    </Card>

    <Modal v-model="modalMatch" fullscreen :title="$t('Comparison')"
      ><!--比较-->
      <div class="modalContent">
        <div>
          <div class="modalRow">
            <div class="rowHeader">{{ $t("Mapping_Fields") }}</div>
            <!--匹配字段-->
            <div
              class="modalCol"
              v-for="(item, index) in userList"
              :key="index"
            >
              <div class="employeeBox">
                <Avatar
                  v-if="item.portrait"
                  :src="'data:image/jpeg;base64,' + item.portrait || ''"
                  size="large"
                />
                <Avatar v-else icon="ios-person" size="large" />
                <div class="employeeContent">
                  <span>{{
                    lang == "zh" ? item.userName : item.userEName
                  }}</span>
                  <p>
                    {{ lang == "zh" ? item.position : item.enPosition }}
                    {{ lang == "zh" ? item.businessUnit : item.enBusinessUnit }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Collapse v-model="modalcollasePanel">
          <Panel name="1" v-if="showMatchFieldList1.length > 0">
            <span>{{ $t("Employee_Information") }}</span
            ><!--基本信息-->
            <div slot="content">
              <div
                class="modalRow"
                v-for="(item, index) in showMatchFieldList1"
                :key="index"
              >
                <div class="rowHeader">{{ item.label }}</div>
                <div
                  class="modalCol"
                  v-for="(el, index) in userTalentComparisonList"
                  :key="index"
                >
                  {{ lang == "zh" ? el[item.value] : el[item.enValue] }}
                </div>
              </div>
            </div>
          </Panel>
          <Panel name="2" v-if="showMatchFieldList2.length > 0">
            <span>{{ $t("PB_Performance_Potential") }}</span
            ><!--绩效潜能-->
            <div slot="content">
              <div
                class="modalRow"
                v-for="(item, index) in showMatchFieldList2"
                :key="index"
              >
                <div class="rowHeader">{{ item.label }}</div>
                <div
                  class="modalCol"
                  v-for="(el, index) in userTalentComparisonList"
                  :key="index"
                >
                  {{ lang == "zh" ? el[item.value] : el[item.enValue] }}
                </div>
              </div>
            </div>
          </Panel>
          <Panel name="3" v-if="showMatchFieldList3.length > 0">
            <span>{{ $t("CAREER_PROFILE") }}</span
            ><!--职业档案-->
            <div slot="content">
              <div
                class="modalRow"
                v-for="(item, index) in showMatchFieldList3"
                :key="index"
              >
                <div class="rowHeader">{{ item.label }}</div>
                <!--职业理想-->
                <div
                  class="modalCol"
                  v-if="item.label == $t('Career_Aspirations')"
                  v-for="(el, index) in userTalentComparisonList"
                  :key="index"
                >
                  {{ lang == "zh" ? el[item.value] : el[item.enValue] }}
                </div>
                <!--嘉士伯工作经历-->
                <Table
                  style="width: 100vw"
                  v-if="item.label == $t('Work_Experience_Carlsberg_Info')"
                  :columns="popColumns1"
                  :data="popDataTable1"
                ></Table>
                <!--之前工作经历-->
                <Table
                  style="width: 100vw"
                  v-if="item.label == $t('Prior_Employment_PPT')"
                  :columns="popColumns2"
                  :data="popDataTable2"
                ></Table>
                <!--教育背景-->
                <Table
                  style="width: 100vw"
                  v-if="item.label == $t('Education_Background')"
                  :columns="popColumns3"
                  :data="popDataTable3"
                ></Table>
              </div>
            </div>
          </Panel>
          <Panel name="4" v-if="showMatchFieldList4.length > 0">
            <span>{{ $t("Development_Plan") }}</span
            ><!--发展计划-->
            <div slot="content">
              <div
                class="modalRow"
                v-for="(item, index) in showMatchFieldList4"
                :key="index"
              >
                <div class="rowHeader">{{ item.label }}</div>
                <div>
                  <Table
                    style="width: 85vw"
                    :columns="popColumns4"
                    :data="popDataTable4"
                  ></Table>
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
import UserGroupList from "../performanceManagement/components/UserGroupList.vue";
export default {
  components: { UserGroupList },
  data() {
    return {
      date: new DateUtil(),
      isShowMore: false,
      collasePanel: [1, 2, 3, 4],
      contentBoxcollasePanel: [1, 2, 3, 4],
      modalcollasePanel: [1, 2, 3, 4],
      prevent: false,
      formItem: {},
      list: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      matchField1: [],
      salesAreaList: [], //销售区域
      YesOrNo: [], //是否
      BeQuit: [], //在职状态
      matchField2: [],
      matchField3: [],
      matchField4: [],
      dataTable: [],
      modalMatch: false,
      peoSelList: [],
      popDataTable1: [],
      popDataTable2: [],
      popDataTable3: [],
      popDataTable4: [],
      Score: [] /* 潜能 */,
      businessUnitList: [] /* 业务单元 */,
      positionList: [] /* 职位 */,
      functionList: [] /* 放入哪个人才库 */,
      Language: [] /* 语言 */,
      CrossRegional: [] /* 跨地域 */,
      YesOrNo: [] /* 跨职能 */,
      Gender: [],
      AchYear: [],
      userList: [],
      userTalentComparisonList: [],
      Band: [],
      PotentialScore: [],
      NextJob: [],
      ServiceRelease: [],
      ExitRisk: [],
      departmentList: [],
      personnelType: [],
      loading: false,
      matchLoading: false,
    };
  },
  computed: {
    matchFieldList1() {
      return [
        { label: this.$t("Age"), value: "age" }, //年龄
        { label: this.$t("Gender"), value: "gender", enValue: "enGender" }, //性别
        {
          label: this.$t("Position"),
          value: "position",
          enValue: "enPosition",
        }, //岗位
        { label: this.$t("Band"), value: "hcmBand" }, //职级
        { label: this.$t("Funciton"), value: "postFun", enValue: "enPostFun" }, //职能
        {
          label: this.$t("Location_PPT"),
          value: "districtChName",
          enValue: "districtEnName",
        }, //工作地点
        { label: this.$t("In position since"), value: "changedate" }, //本岗位开始时间
        { label: this.$t("In Carlsberg since"), value: "hirevalid" }, //嘉士伯入职时间
        {
          label: this.$t("Language_s"),
          value: "chLanguage",
          enValue: "enLanguage",
        }, //语言
      ];
    },
    matchFieldList2() {
      return [
        {
          label: this.$t("PERFORMANCE_PPT") + new Date().getFullYear(),
          value: "wholeScore1",
          enValue: "enWholeScore1",
        }, //绩效
        {
          label: this.$t("PERFORMANCE_PPT") + (new Date().getFullYear() - 1),
          value: "wholeScore2",
          enValue: "enWholeScore2",
        },
        {
          label: this.$t("PERFORMANCE_PPT") + (new Date().getFullYear() - 2),
          value: "wholeScore3",
          enValue: "enWholeScore3",
        },
        // {label:this.$t('PERFORMANCE_PPT')+ (new Date().getFullYear()-3),value:'wholeScore4'},
        // {label:this.$t('PERFORMANCE_PPT')+ (new Date().getFullYear()-4),value:'wholeScore5'},
        {
          label: this.$t("Potential") + new Date().getFullYear(),
          value: "potentialScore1",
          enValue: "enPotentialScore1",
        }, //潜能
        {
          label: this.$t("Potential") + (new Date().getFullYear() - 1),
          value: "potentialScore2",
          enValue: "enPotentialScore2",
        },
        {
          label: this.$t("Potential") + (new Date().getFullYear() - 2),
          value: "potentialScore3",
          enValue: "enPotentialScore3",
        },
        // {label:this.$t('Potential')+ (new Date().getFullYear()-3),value:'potentialScore4'},
        // {label:this.$t('Potential')+ (new Date().getFullYear()-4),value:'potentialScore5'},
        {
          label: this.$t("Attrition_Risk"),
          value: "exitRisk",
          enValue: "enExitRisk",
        }, //离职风险
        { label: this.$t("Impact_of_Attrition"), value: "exitAffect" }, //离职影响
        {
          label: this.$t("Mobility_Cross_Region"),
          value: "crossRegional",
          enValue: "enCrossRegional",
        }, //能动性（跨地域）
        {
          label: this.$t("Mobility_Cross_Function"),
          value: "crossFun",
          enValue: "enCrossFun",
        }, //能动性（跨职能）
        {
          label: this.$t("Readiness_for_Next_Position"),
          value: "nextJob",
          enValue: "enNextJob",
        }, //下一岗位的准备度Readiness
        {
          label: this.$t("Releasibility_"),
          value: "releaseDate",
          enValue: "enReleaseDate",
        }, //业务可释放的时间Releasability
        {
          label: this.$t("Talent_Pool"),
          value: "postFun",
          enValue: "enPostFun",
        }, //放入哪个人才库
        { label: this.$t("Successor Candidate_Role"), value: "successor" }, //哪个岗位的继任者
        { label: this.$t("Talent Tag"), value: "ability" }, //能力标签
      ];
    },
    matchFieldList3() {
      return [
        { label: this.$t("Career_Aspirations"), value: "careerIdeal" }, //职业理想
        { label: this.$t("Work_Experience_Carlsberg_Info"), value: "21" }, //嘉士伯工作经历
        { label: this.$t("Prior_Employment_PPT"), value: "22" }, //之前工作经历
        { label: this.$t("Education_Background"), value: "23" }, //教育背景
      ];
    },
    matchFieldList4() {
      return [
        { label: this.$t("Development_Plan"), value: "24" }, //发展计划
      ];
    },
    columns() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: this.$t("PB_Employee"), //'员工'
          slot: "userName",
        },
      ];
    },
    popColumns1() {
      return [
        {
          title: this.$t("Employee_Code"), //'工号'
          key: "empCode",
          minWidth: 200,
        },
        {
          title: this.$t("Name"), //'姓名'
          key: this.lang == "zh" ? "userName" : "userEName",
          minWidth: 200,
        },
        {
          title: this.$t("Start_Date"), //'开始日期'
          key: "positionStartDate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.positionStartDate, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("End_Date"), //'结束日期'
          key: "positionEndDate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.positionEndDate, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("Position"), //'职位'
          key: this.lang == "zh" ? "positionCName" : "positionEName",
          minWidth: 200,
        },
      ];
    },
    popColumns2() {
      return [
        {
          title: this.$t("Employee_Code"), //'工号'
          key: "empCode",
          minWidth: 200,
        },
        {
          title: this.$t("Name"), //'姓名'
          key: this.lang == "zh" ? "userName" : "userEName",
          minWidth: 200,
        },
        {
          title: this.$t("Former_Company"), //'前任公司'
          key: "eEmployerName",
          minWidth: 200,
        },
        {
          title: this.$t("Position"), //'职位'
          key: "e_title",
          minWidth: 200,
        },
        {
          title: this.$t("Start_Date"), //'开始日期'
          key: "startdate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startdate, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("End_Date"), //'结束日期'
          key: "enddate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.enddate, "YYYY-MM-DD")
            );
          },
        },
      ];
    },
    popColumns3() {
      return [
        {
          title: this.$t("Employee_Code"), //'工号'
          key: "empCode",
          minWidth: 200,
        },
        {
          title: this.$t("Name"), //'姓名'
          key: this.lang == "zh" ? "userName" : "userEName",
          minWidth: 200,
        },
        {
          title: this.$t("Start_Date"), //'开始日期'
          key: "programstartdate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.programstartdate, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("Graduation_Date"), //'毕业日期'
          key: "graduatedate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.graduatedate, "YYYY-MM-DD")
            );
          },
        },
        {
          title: this.$t("School"), //'学校名称'
          key: "school",
          minWidth: 200,
        },
        {
          title: this.$t("Major"), //'专业名称'
          key: "major",
          minWidth: 200,
        },
        {
          title: this.$t("Academic_Level"), //'学历'
          key: this.lang == "zh" ? "degree" : "enDegree",
          minWidth: 200,
        },
        {
          title: this.$t("_Degree"), //'学位'
          key: this.lang == "zh" ? "academicdegree" : "enAcademicdegree",
          minWidth: 200,
        },
        {
          title: this.$t("Program_Duration"), //'学年制'
          key: "programyears",
          minWidth: 200,
        },
        {
          title: this.$t("Highest_Education"), //'最高学历'
          key: this.lang == "zh" ? "highest" : "enHighest",
          minWidth: 200,
        },
      ];
    },
    popColumns4() {
      return [
        {
          title: this.$t("Employee_Code"), //'工号'
          key: "empCode",
          minWidth: 200,
        },
        {
          title: this.$t("Name"), //'姓名'
          key: this.lang == "zh" ? "userName" : "userEName",
          minWidth: 200,
        },
        {
          title: this.$t("Development_Objectives"), //'发展目标'
          key: "developTarget",
          minWidth: 200,
        },
        {
          title: this.$t("Detailed_Description"), //'详细描述'
          key: "details",
          minWidth: 200,
        },
        {
          title: this.$t("Employee_Comment"), //'员工说明'
          key: "empDetails",
          minWidth: 200,
        },
        {
          title: this.$t("Line_Manager_Feedback"), //'直线上级反馈'
          key: "dirSupFeedback",
          minWidth: 200,
        },
      ];
    },
    // userList () {
    //     return this.peoSelList
    // },
    showMatchFieldList1() {
      return this.matchFieldList1.filter((item) => {
        return this.matchField1.includes(item.value);
      });
    },
    showMatchFieldList2() {
      return this.matchFieldList2.filter((item) => {
        return this.matchField2.includes(item.value);
      });
    },
    showMatchFieldList3() {
      return this.matchFieldList3.filter((item) => {
        return this.matchField3.includes(item.value);
      });
    },
    showMatchFieldList4() {
      return this.matchFieldList4.filter((item) => {
        return this.matchField4.includes(item.value);
      });
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  created() {
    if (this.$route.query.id) {
      document.title = this.$t("Talent_Comparison"); //人才比对
    }
    this.getListData();
    this.getData();
  },
  methods: {
    confirmSelectGroup(list) {
      this.formItem.userGroupList = JSON.parse(JSON.stringify(list));
    },

    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.Score = res.Score;
          this.businessUnitList = res.businessUnitList;
          this.positionList = res.positionList;
          this.functionList = res.functionList;
          this.Language = res.Language;
          this.CrossRegional = res.CrossRegional;
          this.salesAreaList = res.salesAreaList;
          this.BeQuit = res.BeQuit;
          this.YesOrNo = res.YesOrNo;
          this.Gender = res.Gender;
          this.AchYear = res.AchYear;
          this.Band = res.Band;
          this.PotentialScore = res.PotentialScore;
          this.NextJob = res.NextJob;
          this.ServiceRelease = res.ServiceRelease;
          this.ExitRisk = res.ExitRisk;
          this.departmentList = res.departmentList;
          this.personnelType = res.personnelType;
        }
      });
    },
    getData() {
      this.loading = true;
      axios
        .post("/talentComparison/selectUserTalentComUser", {
          ...this.pageInfo,
          ...this.formItem,
        })
        .then((res) => {
          this.loading = false;
          if (res) {
            this.dataTable = res.data;
            this.total = parseInt(res.pageInfo.total);
            this.dataTable.forEach((el) => {
              el._checked = false;
              this.userList.forEach((item, index) => {
                if (el.serialnumber == item.serialnumber) {
                  el._checked = true;
                }
              });
            });
          }
        });
    },
    peoOnSelect(selection, row) {
      // console.log(selection)
      // selection.forEach(el => {
      //     this.peoSelList.push(el)
      // })
      // this.userList=[...new Set(this.peoSelList)];
    },
    peoOnSelectRow(selection, row) {
      if (!this.userList.includes(row.serialnumber)) {
        this.userList.push(row);
      }
    },
    TableSelectCancelRow(selection, row) {
      this.userList.forEach((el, index) => {
        if (el.serialnumber == row.serialnumber) {
          this.userList.splice(index, 1);
        }
      });
    },
    selsetAll(selection) {
      this.dataTable.forEach((el) => {
        this.userList.push(el);
      });
      let map = new Map();
      for (let item of this.userList) {
        map.set(item.serialnumber, item);
      }
      this.userList = [...map.values()];
    },
    cancelAll(selection) {
      this.dataTable.forEach((row) => {
        this.userList.forEach((el, index) => {
          if (el.serialnumber == row.serialnumber) {
            this.userList.splice(index, 1);
          }
        });
      });
    },
    modalMatchClick() {
      if (this.userList.length <= 0) {
        this.$Message.info(this.$t("请选择员工")); //请选择员工
        return;
      }
      if (
        this.matchField1.length <= 0 &&
        this.matchField2.length <= 0 &&
        this.matchField3.length <= 0 &&
        this.matchField4.length <= 0
      ) {
        this.$Message.info(this.$t("请选择比对项目")); //请选择员工
        return;
      }
      let array = [];
      this.userList.forEach((el) => {
        array.push({ serialnumber: el.serialnumber });
      });
      this.userTalentComparisonList = [];
      this.matchLoading = true;
      axios
        .post("/talentComparison/selectUserTalentComData", array)
        .then((res) => {
          this.matchLoading = false;
          if (res) {
            this.userList.forEach((item) => {
              res.userTalentComparisonList.forEach((el) => {
                if (el.serialnumber == item.serialnumber) {
                  this.userTalentComparisonList.push(el);
                }
              });
            });

            // this.userTalentComparisonList=res.userTalentComparisonList
            this.popDataTable1 = res.carlsbergWorkList;
            this.popDataTable2 = res.lastWorkList;
            this.popDataTable3 = res.educationList;
            this.popDataTable4 = res.developmentPlanList;
            this.modalMatch = true;
          }
        });
    },
    // 绩效、潜能可勾选3个
    matchFieldList2OnChange(val) {
      let jxNum = 0;
      let qnNum = 0;
      val.map((item) => {
        if (item.indexOf("9-") != -1) {
          jxNum++;
        }
        if (item.indexOf("10-") != -1) {
          qnNum++;
        }
      });
      this.matchFieldList2.map((item) => {
        item.disabled = false;
        if (
          jxNum > 2 &&
          item.value.indexOf("9-") != -1 &&
          !val.includes(item.value)
        ) {
          item.disabled = true;
        }

        if (
          qnNum > 2 &&
          item.value.indexOf("10-") != -1 &&
          !val.includes(item.value)
        ) {
          item.disabled = true;
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    handleReset() {
      this.formItem = {};
      this.$refs.UserGroupList.selectModalGroupList = [];
      this.$refs.UserGroupList.formItem.userGroupList = [];
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    },
  },
};
</script>

<style lang="less" scoped>
.cs-more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
/deep/.ivu-collapse {
  border: none !important;
  // width:100% !important;
}
.modalContent /deep/ .ivu-collapse {
  // height: 100vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  width: auto;
}
/deep/.ivu-collapse > .ivu-collapse-item {
  border-top: none !important;
}
/deep/.ivu-collapse-content > .ivu-collapse-content-box {
  padding-bottom: 0px !important;
  padding-top: 10px !important;
}
.searchBtn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.contentBox {
  display: flex;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.employeeBox {
  display: flex;
  padding: 10px 0;
}
.employeeContent {
  margin-left: 20px;
}
.matchFieldLeft {
  width: 48%;
  background: #f7f7f7;
  /deep/.ivu-collapse-content {
    background: #f7f7f7 !important;
  }
  /deep/.ivu-collapse-simple {
    background: #f7f7f7 !important;
  }
}
.matchFieldRight {
  width: 50%;
  margin-left: 2%;
}
@media screen and (max-width: 800px) {
  .matchFieldLeft {
    width: 100%;
    background: #f7f7f7;
  }
  .matchFieldRight {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
  }
}
.modalContent {
  /deep/.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
    padding-left: 10px !important;
    color: #ffffff;
    background-color: #22c3aa;
  }
  /deep/.ivu-collapse {
    display: inline-block;
  }
  /deep/.ivu-collapse-content > .ivu-collapse-content-box {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }
  /deep/.ivu-collapse-content {
    padding: 0 !important;
  }
  .modalCol {
    border-right: 1px solid #d1d1d1;
    border-bottom: 1px solid #d1d1d1;
    padding: 20px;
    background: #ffffff;
    white-space: normal;
    min-height: 100px;
  }
}
.modalRow {
  display: flex;
  width: 100%;
  // padding: 20px;
  align-items: center;
  white-space: nowrap;
  background: #f7f7f7;
}
.rowHeader {
  padding: 0 20px;
  background: #f7f7f7;
  max-width: 250px;
  min-width: 250px;
}
div.modalCol {
  display: grid;
  grid-template-columns: minmax(200px, 300px);
  grid-gap: 10px;
}
/deep/.ivu-modal-fullscreen .ivu-modal-body {
  overflow-y: auto;
  height: 100% !important;
  max-height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/TalentContrast.vue